
export class Configurations {
    public env: any = null;

    constructor(env: any) {
        this.env = env;
    }
}